import clsx from 'clsx'

interface IconProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>
  size?: number
  color?: string
  className?: string
  onClick?: () => void
}

export const Icon = ({ icon: IconSvg, size = 20, color = 'currentColor', className, onClick }: IconProps) => {
  return (
    <IconSvg width={size} height={size} fill={color} className={clsx(className)} style={{ color }} onClick={onClick} />
  )
}
